
const timeStampConverter = {

  /**
   * convert date and time in ISO 8601 standard
   * @param date
   * @returns {string|*}
   */
  getDateAndTime (date) {
    const newISOString = Date.prototype.toISOString
    if (!date) return date
    const regex = /(?:GMT)([-+]\d*)/gm
    let gtm = regex.exec(date.toString())[1]
    gtm = [...gtm]
    gtm.splice(3, 0, ':')
    gtm = gtm.join('')
    return newISOString.apply(date).replace('Z', gtm)
  }

}

export default timeStampConverter
